import type * as React from 'react';
import { View as RNView, type StyleProp, type ViewStyle } from 'react-native';

import { Description, type IconDefinition, Label, renderIcon } from '@gitbook/spine-react';

import { flex } from '../constants';

/**
 * Actions in a form.
 */
export function FormButton(props: {
    label: React.ReactNode;
    labelDescription?: React.ReactNode;
    labelSelectable?: boolean;

    /**
     * Optional badge displayed after the label
     */
    badge?: React.ReactNode;

    /** Icon rendered on the left side */
    icon?: IconDefinition;
    style?: StyleProp<ViewStyle>;
    children?: React.ReactNode;
}): React.ReactElement {
    const { label, labelDescription, badge, labelSelectable, icon, style, children } = props;
    return (
        <RNView style={[flex.row, flex.alignItemsCenter, style]}>
            {icon ? renderIcon(icon, { size: 20, className: 'text-muted mr-4' }) : null}
            <div className="flex flex-1 flex-col">
                <div className="mb-1 flex items-center gap-2">
                    <Label className={labelSelectable ? 'select-all' : undefined}>{label}</Label>
                    {badge}
                </div>
                {labelDescription ? (
                    <div className="flex">
                        <Description className={labelSelectable ? 'select-all' : undefined}>
                            {labelDescription}
                        </Description>
                    </div>
                ) : null}
            </div>
            <div className="ml-4 flex">{children}</div>
        </RNView>
    );
}
